// Search

import {
  applyComparisonOperator,
  applyDateRangeFilter,
  parseFilters,
} from '../../../libs/filter.lib'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import {
  MovementField,
  MovementSearchParams,
  MovementSortField,
} from '../models/movement-search.model'

export function parseMovementFilters(
  params: MovementSearchParams,
  filters: MovementSearchParams,
): MovementSearchParams {
  return parseFilters(params, filters, movementFilterParams)
}

export function movementSortParams(
  params: MovementSearchParams,
  sort: QueryStringSort<MovementSortField>,
): MovementSearchParams {
  const searchParams: MovementSearchParams = {}

  switch (sort.field) {
    case 'createdAt':
      searchParams.sort = 'createdAt'
      searchParams.order = sort.order
      break
    case 'SKU':
      searchParams.sort = 'SKU'
      searchParams.order = sort.order
      break
    case 'name':
      searchParams.sort = 'name'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

export function movementFilterParams(
  params: MovementSearchParams,
  filter: QueryStringFilter<MovementField>,
): MovementSearchParams {
  const searchParams: MovementSearchParams = {}
  const value = Array.isArray(filter.value)
    ? filter.value.length
      ? filter.value[0]
      : undefined
    : filter.value

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'createdAt':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'createdAt',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'createdAt',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'SKU':
      if (filter.operator === '=') {
        searchParams.SKU = filter.value
      }
      break
    case 'name':
      if (filter.operator === '=') {
        searchParams.name = filter.value
      }
      break
    case 'sign':
      if (filter.operator !== null) {
        searchParams.sign = filter.value
      }
      break
    case 'reason':
      if (filter.operator !== null) {
        searchParams.reason = filter.value
      }
      break
    case 'details.code':
      if (filter.operator === '=') {
        searchParams['details.code'] = filter.value
      }
      break
    case 'order.orderNumber':
      if (filter.operator === '=') {
        searchParams['order.orderNumber'] = filter.value
      }
      break
    case 'order.rifOrder':
      if (filter.operator === '=') {
        searchParams['order.rifOrder'] = filter.value
      }
      break
    case 'userId':
      if (filter.operator !== null) {
        searchParams.userId = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
